import React, { useEffect } from 'react';
import { Loader } from '@hpi-sox/hpstellar-core';

import './page-placeholder.less';

//page placeholder to be use during client side routing
export default ({ ssr = false }) => {
    //reset scroll position on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    //never render the loader on the server
    if (!ssr && process.env.ISNODE) {
        return null;
    }
    return (
        <div id="pageloader" className="page-placeholder">
            <Loader
                id="pageloader"
                translations={{
                    label: 'Loading...',
                }}
                style={{ height: '500px' }}
            />
        </div>
    );
};
